import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import SimilarProducts from '../../components/SimilarProducts/SimilarProducts'
import ProdDetail from './ProdDetail'
import RecentlyViewed from '../../components/RecentlyViewed/RecentlyViewed'
import CustomSeparator from '../../components/maincomps/breadcrumbs/Breadcrumbs'
import breadcrumbStyle from '../../components/maincomps/breadcrumbs/breadcrumbs.module.css'
import Loader from '../../components/Loader/Loader'
import { getAllProductsById, increamentProductCount } from '../../../redux/productsSlice'
import { useCurrency } from '../../../Website/context/CurrencyContext'
import ScrollToTop from "../../components/Loader/ScrollToTop";


const ProdDescription = () => {

  const { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const { productsByIdData, isLoading } = useSelector((state) => state.products);
  const { formatPrice } = useCurrency();

  const categoryId = productsByIdData?.product?.category?.productCategory?._id;

  // ✅ Track if at least one fetch has completed
  const [hasFetched, setHasFetched] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(getAllProductsById(id))
      dispatch(increamentProductCount(id))
      setHasFetched(true)
    }
    fetchData()
  }, [dispatch, id]);

  // useEffect(() => {
  //   window.scrollTo(0, 0)
  // }, [location]);

  return (
    <>
      <ScrollToTop />

      <div className={breadcrumbStyle.breadcrumbStyle}>
        <CustomSeparator
          home="Home"
          type={productsByIdData?.product?.category?.productCategory?.name}
          subType={productsByIdData?.product?.productName}
          id={categoryId}
        />
      </div>

      {!hasFetched ? (
        <Loader />
      ) : productsByIdData ? (
        <>
          <ProdDetail productsByIdData={productsByIdData} formatPrice={formatPrice} />
          <SimilarProducts similarProducts={productsByIdData} />
        </>
      ) : (
        <p>No product found</p>
      )}

      <RecentlyViewed />
    </>
  );
};

export default ProdDescription;
